import * as Actions from 'app/store/actions/fuse';

const initialState = {
	providers: [],
	server: 'http://localhost:12345',
	register: true
};

const config = function (state = initialState, action) {
	switch (action.type) {
		case Actions.SET_CONFIG: {
			return {
				...state,
				providers: action.payload.providers,
				server: action.payload.server,
				register: action.payload.register
			};
		}

		default:
			return state;
	}
};

export default config;
